module.exports = __webpack_public_path__ + "img/guizhouHints_22.987de6c8.jpg";